import { render, staticRenderFns } from "./BasicsForm.vue?vue&type=template&id=03868206&scoped=true&"
import script from "./BasicsForm.vue?vue&type=script&lang=js&"
export * from "./BasicsForm.vue?vue&type=script&lang=js&"
import style0 from "./BasicsForm.vue?vue&type=style&index=0&id=03868206&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03868206",
  null
  
)

export default component.exports